import { Avatar, Popover } from '@mantine/core';

import { ReactComponent as DelectIcon } from 'assets/icons/blogDeleteIcon.svg';
import { ReactComponent as MenuThree } from 'assets/icons/menudots.svg';

import dayjs from 'dayjs';
import { useState } from 'react';
import AddNewStroryModal from './addnewstrorymodal';
import DeleteStoryModal from './deletestoryModal';
import PublishModal from './publishModal';
import UnpublishBlog from './unpublishBlog';
import useUpdateblog from '../hooks/useUpdateblog';
import Usedeleteblog from '../hooks/usedeleteblog';
const PublishRowTableRows = ({ data, name }) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [BlogId, setBlogId] = useState(null);
  const [newStoryModal, setNewStoryModal] = useState(false);
  const [unpublishModal, setUnpublishModal] = useState(false);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [publishModal, setPublishModal] = useState(false);
  const [publishData, setPublishData] = useState(null);
  const useupdateAdminBlog = useUpdateblog();
  const deleteBlog = Usedeleteblog();

  const extractContent = (s) => {
    const span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };
  // console.log('name:', name);
  return (
    <>
      <tr>
        <td className='w-[250px]'>
          <p className='flex justify-start pl-14 items-center gap-3 text-[#9B9B9B]'>
            <Avatar radius='xl' color='#FB7C51' src={data?.profile_picture}>
              {data?.user__first_name[0]?.toUpperCase()}
            </Avatar>
            {data?.user__first_name}
          </p>
        </td>
        <td className='text-[#FB7C51] text-center'>{data?.topic}</td>
        <td className='w-[350px]'>
          <h1 className='text-lg font-bold '>{data?.title}</h1>
          <p className='text-sm text-[#9B9B9B] mt-1'>
            {`${extractContent(data?.content).substring(0, 80)}........`}
          </p>
          <p className='text-[#9B9B9B] flex justify-between items-center mt-1'>
            {dayjs(`${data?.created_date}`).format('H:mm A , D MMM YYYY ')}
            <span>{data?.minutes} min read</span>
          </p>
        </td>
        <td className='w-[100px]  '>
          {name === 'Delete' ? null : (
            <>
              {data?.requested_delete ? (
                <div
                  className='text-[#FB0C51] text-normal bg-[#FFEBE5] p-2 px-2 w-fit  rounded-full font-bold flex items-center gap-2 cursor-pointer'
                  onClick={() => {
                    setDeleteModal(true);
                    setBlogId(data?.id);
                  }}
                >
                  <DelectIcon className='cursor-pointer' />
                  <h1>Requested</h1>
                </div>
              ) : null}
            </>
          )}
        </td>

        <td className='w-[150px] '>
          <div className='flex justify-center items-center gap-3 '>
            <p
              className='text-[#67A1EF] font-semibold text-normal cursor-pointer'
              onClick={() => {
                setNewStoryModal(true);

                setBlogId(data?.id);
              }}
            >
              view
            </p>
            {name === 'Delete' ? (
              <Popover
                opened={popoverOpen}
                onClose={() => setPopoverOpen(false)}
                target={
                  <p
                    className='cursor-pointer '
                    onClick={() => setPopoverOpen(!popoverOpen)}
                  >
                    <MenuThree className='h-5 w-5 cursor-pointer' />
                  </p>
                }
                // width={220}
                // className='rounded-lg shadow-lg'
              >
                <p
                  className='cursor-pointer py-2 text-[#8E8E8E]'
                  onClick={() => {
                    setNewStoryModal(true);
                    setBlogId(data?.id);
                  }}
                >
                  Edit
                </p>
                <hr className='text-[#8E8E8E] opacity-50' />
                <p
                  className='cursor-pointer py-2 text-[#8E8E8E]'
                  onClick={() => {
                    useupdateAdminBlog.mutate({
                      id: data?.id,
                      is_deleted: 'False',
                      is_draft: 'True',
                    });
                  }}
                >
                  Restore
                </p>
                <hr className='text-[#8E8E8E] opacity-50' />
                <p
                  className='cursor-pointer py-2 text-[#8E8E8E]'
                  onClick={() => {
                    deleteBlog.mutate({
                      id: data?.id,
                    });
                  }}
                >
                  Delete Permanently
                </p>
              </Popover>
            ) : (
              <Popover
                opened={popoverOpen}
                onClose={() => setPopoverOpen(false)}
                target={
                  <p
                    className='cursor-pointer '
                    onClick={() => setPopoverOpen(!popoverOpen)}
                  >
                    <MenuThree className='h-5 w-5 cursor-pointer' />
                  </p>
                }
                // width={220}
                // className='rounded-lg shadow-lg'
              >
                <p
                  className='cursor-pointer py-2 text-[#8E8E8E]'
                  onClick={() => {
                    setUnpublishModal(true);
                    setPopoverOpen(false);
                    setBlogId(data?.id);
                  }}
                >
                  Unpublish
                </p>
                <hr className='text-[#8E8E8E] opacity-50' />
                <p
                  className='cursor-pointer py-2 text-[#8E8E8E]'
                  onClick={() => {
                    setPublishModal(true);
                    setPublishData(data?.published_on);
                    setBlogId(data?.id);
                    setPopoverOpen(false);
                  }}
                >
                  Publish to a new domain
                </p>
              </Popover>
            )}
          </div>
        </td>
      </tr>
      <DeleteStoryModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        blogId={BlogId}
        setBlogId={setBlogId}
      />
      <AddNewStroryModal
        setNewStoryModal={setNewStoryModal}
        newStoryModal={newStoryModal}
        setBlogId={setBlogId}
        BlogId={BlogId}
      />
      <PublishModal
        setPublishModal={setPublishModal}
        publishModal={publishModal}
        publishData={publishData}
        setPublishData={setPublishData}
        BlogId={BlogId}
        setBlogId={setBlogId}
      />
      <UnpublishBlog
        setUnpublishModal={setUnpublishModal}
        unpublishModal={unpublishModal}
        publishData={publishData}
        setPublishData={setPublishData}
        BlogId={BlogId}
        setBlogId={setBlogId}
      />
    </>
  );
};
export default PublishRowTableRows;
